import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const contractorSettingsApi = createApi({
  reducerPath: "contractorSettingsApi",
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ["ContractorSettings"],
  endpoints: (builder) => ({
    // 🔹 Get Contractor Settings
    getContractorSettings: builder.query({
      query: () => ({
        url: `/contractor/settings`,
        method: "GET",
      }),
      providesTags: ["ContractorSettings"],
    }),

    // 🔹 Update Contractor Settings
    updateContractorSettings: builder.mutation({
      query: ({ data }) => ({
        url: `/contractor/settings`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["ContractorSettings"],
    }),
  }),
});

// ✅ Export hooks
export const {
  useGetContractorSettingsQuery,
  useUpdateContractorSettingsMutation,
} = contractorSettingsApi;
